<script>
  import storeGlobal, { storeFilters } from "../../stores/storeGlobal";

  export let name;
  export let filter;

  $: darkMode = $storeGlobal.darkMode;
  let checked = $storeFilters[filter];

</script>

<style>
  .switch {
    @apply relative select-none w-10 mr-2 leading-normal;
  }

  .switch-checkbox {
    @apply hidden;
  }

  .switch-label {
    @apply block overflow-hidden cursor-pointer bg-snow_d border rounded-full h-5 shadow-inner;
    transition: background-color 0.2s ease-in;
  }

  .switch-label:before {
    @apply absolute block bg-white w-5 border rounded-full -ml-1;

    right: 50%;
    content: "";
    transition: all 0.2s ease-in;
    top: 0;
    bottom: 0;
  }

  .switch-checkbox:checked + .switch-label,
  .switch-checkbox:checked + .switch-label:before {
  }

  .switch-checkbox:checked + .switch-label {
    @apply bg-teal shadow-none h-5;
  }
  .switch-checkbox:checked + .switch-label:before {
    @apply right-0;
  }

  /* Darkmode */
  .dark {
    @apply relative select-none w-10 mr-2 leading-normal;
  }

  .dark-checkbox {
    @apply hidden;
  }

  .dark-label {
    @apply block overflow-hidden cursor-pointer bg-slate border border-slate rounded-full h-5 shadow-inner;
    transition: background-color 0.2s ease-in;
  }

  .dark-label:before {
    @apply absolute block bg-steel inset-y-0 w-5 border border-slate rounded-full -ml-1;

    right: 50%;
    content: "";
    transition: all 0.2s ease-in;
  }

  .dark-checkbox:checked + .dark-label,
  .dark-checkbox:checked + .dark-label:before {
  }

  .dark-checkbox:checked + .dark-label {
    @apply bg-teal shadow-none h-5;
  }
  .dark-checkbox:checked + .dark-label:before {
    @apply right-0;
  }
</style>

<!-- Markup -->

{#if !darkMode}
  <div class="inline-block flex mt-4 items-center">
    <div class="switch inline-block align-middle">
      <input class="switch-checkbox" id="{ name }" name="{ name }" type="checkbox" on:click bind:checked={checked} />
      <label class="switch-label dark:border-slate dark:bg-blackd" for="{ name }"></label>
    </div>
    <label for="{ name }" class="text-sm text-silver">{ name }</label>
  </div>
{:else}
  <div class="inline-block flex mt-4 items-center">
    <div class="dark inline-block align-middle">
      <input class="dark-checkbox" id="{ name }" name="{ name }" type="checkbox" on:click bind:checked={checked}/>
      <label class="dark-label dark:border-slate" for="{ name }"></label>
    </div>
    <label for="{ name }" class="text-sm text-silver">{ name }</label>
  </div>
{/if}
